import { ChangeEvent, Dispatch, FC, useEffect, useState } from 'react'

import { AxiosError } from 'axios'
import {
  Button,
  Card,
  Grid,
  Input,
  Row,
  Select,
  SimpleCollapse
} from 'components'
import { useAuth, useLoading, useModal } from 'hooks'
import {
  ParamFaleConoscoResponseDto,
  TalkWithUsServices
} from 'services/NGT/Parameterization'
import TalkToUsService, { ITalkToUsEntityResponse } from 'services/NGT/TalkToUs'
import { COLORS, SPACING } from 'utils'
import { UserServices } from 'services/Supplier/Users'
import React from 'react'

interface ITalkToUsForm {
  idFaleConosco: number
  setSelectedTab: Dispatch<React.SetStateAction<number>>
}

export interface IBuscarUsuarioPorIdResponse {
  cdDocto: string;
  idUsuario: number;
  nmUsuario: string;
  nuContato: string;
  txEmail: string;
}

export interface IHistoricoRelacionado {
  message: string;
  answer: string;
}

const DEFAULT_TALK_TO_US: ITalkToUsEntityResponse = {
  dtEnvio: '',
  faleConoscoId: 0,
  idParamFaleConosco: 0,
  idUsuario: 0,
  txtMensagem: '',
  txtResposta: '',
  contrato: ''
}

const TalkToUsForm: FC<ITalkToUsForm> = ({ idFaleConosco, setSelectedTab }) => {
  const { showModal } = useModal()
  const { user } = useAuth()
  const { setLoading } = useLoading()
  const [respondido, setRespondido] = useState<boolean>(false)

  const [parametrizationTalkToUs, setParametrizationTalkToUs] =
    useState<ParamFaleConoscoResponseDto>()
  const [talkToUs, setTalkToUs] =
    useState<ITalkToUsEntityResponse>(DEFAULT_TALK_TO_US)

  const [userSolicitanteName, setUserData] = useState<string>();

  const [userMessage, setUserMessage] = useState<string>();
  const [userContrato, setUserContrato] = useState<string>();
  const [historicoEncontrado, setHistoricoEncontrado] = useState<boolean>();
  const [historicoData, setHistoricoData] = useState<Array<IHistoricoRelacionado>>();

  const handleSearchTalkToUsParametrization = (idParamFaleConosco: number) => {
    TalkWithUsServices()
      .getById(idParamFaleConosco)
      .then(({ data }) => {
        if (data) {
          setParametrizationTalkToUs(data)
        }
      })
      .catch((error) => {
        const axiosError = error as AxiosError

        showModal({
          hideButtonCancel: true,
          message:
            axiosError.message ||
            'Não foi possivel obter as parametrizações de fale conosco',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleReturn = () => setSelectedTab(0)

  const handleUserContratoMessage = (data: ITalkToUsEntityResponse)  => {
    if(data){
      try {
        const userMessageContrato = JSON.parse(data.txtMensagem);
        setUserMessage(userMessageContrato.message);
        setUserContrato(userMessageContrato.CDContrato);
        handleSearchHistorico(data, userMessageContrato.CDContrato);
      } catch (error) {
          setHistoricoEncontrado(false);
          setUserContrato("NÃO INFORMADO!");
          setUserMessage(data.txtMensagem);
      }
    }
  }

  const handleSearchUserData = (data: ITalkToUsEntityResponse) => {
    UserServices()
    .buscarUsuarioPorID(data.idUsuario)
    .then((response) => {
      setUserData(response.data.txEmail)
    })
  }

  const handleSearchHistorico = (data: ITalkToUsEntityResponse, CDContrato: string) => {
    const requestParams = {
        CDContrato: CDContrato,
        IdMotivo: data.idParamFaleConosco,
        IdUsuario: data.idUsuario
    }
    TalkToUsService()
        .buscarHistorico(requestParams)
        .then((response) => {
          const historicoRelacionado : Array<IHistoricoRelacionado> = [];
          if(response.data.length > 1){
            response.data.map((item) => {
              const userMessageContrato = JSON.parse(item.txtMensagem);
              const historicoData = {
                answer: item.txtResposta == "" ? "SEM RESPOSTA!" : item.txtResposta,
                message: userMessageContrato.message,
              }
              historicoRelacionado.push(historicoData);
            });
            setHistoricoEncontrado(true);
            setHistoricoData(historicoRelacionado);
          }
        })
        .catch((error) => {
          console.error("handleSearchHistorico error => ", error);
        });
  }

  const handleSearchTalkToUs = () => {
    setLoading('loading')

    TalkToUsService()
      .getById(idFaleConosco)
      .then(({ data }) => {
        if (data) {
          handleSearchUserData(data);
          setTalkToUs(data);
          handleUserContratoMessage(data);
          setRespondido(data.txtResposta?.trim().length > 0)
          handleSearchTalkToUsParametrization(data.idParamFaleConosco)
        }
      })
      .catch((error) => {
        const axiosError = error as AxiosError

        showModal({
          hideButtonCancel: true,
          message:
            axiosError.message ||
            'Não foi possivel obter as parametrizações de fale conosco',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
      .finally(() => setLoading('idle'))
  }

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setTalkToUs((oldData) => {
      return {
        ...oldData,
        [event.target.name]: event.target.value
      }
    })
  }

  const handleOnSave = () => {
    setLoading('loading')

    TalkToUsService()
      .update({ ...talkToUs, idUsuarioCsn: user.IdUsuario })
      .then(() => {
        showModal({
          handleConfirm: handleReturn,
          hideButtonCancel: true,
          message: 'Resposta enviada com sucesso.',
          txtButtonConfirm: 'OK',
          type: 'success'
        })
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel enviar a mensagem',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
      .finally(() => setLoading('idle'))
  }

  useEffect(() => {
    handleSearchTalkToUs()
  }, [])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >

{historicoEncontrado && (

<SimpleCollapse title="Histórico Relacionado" textColor={COLORS.black}>
        <Grid
          gridCols="1fr 1.5fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
            <Select
              label="Motivo"
              formValue="idMotivo"
              value={parametrizationTalkToUs?.idParamFaleConosco || 0}
              disabled
              key="idParamFaleConosco"
              labelMenu="dsMotivo"
              valueMenu="idParamFaleConosco"
              listOptions={
                parametrizationTalkToUs?.idParamFaleConosco
                  ? [parametrizationTalkToUs]
                  : []
              }
            />
            <Input
              label="Contrato"
              value={userContrato}
              onChange={handleOnChange}
              maxLength={4000}
              disabled
              multiline
              formValue={`userContrato`}
              placeholder="Mensagem"
            />
        </Grid>
        {historicoData && historicoData.length > 0 && historicoData.map((item, index) => (
        <React.Fragment key={`historico_${index}`}>
        <Grid
          gridCols="1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Input
            label="Mensagem"
            value={item.message}
            disabled
            formValue={`txtMensagem_${index}`}
          />
          <Input
            label="Resposta"
            value={item.answer}
            disabled
            formValue={`txtResposta_${index}`}
          />
        </Grid>
      </React.Fragment>
    ))}
  </SimpleCollapse>
)}


      <SimpleCollapse title="Fale Conosco" textColor={COLORS.black}>
        <Grid
          gridCols="1fr 1.5fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Select
            label="Motivo"
            formValue="idMotivo"
            value={parametrizationTalkToUs?.idParamFaleConosco || 0}
            disabled
            key="idParamFaleConosco"
            labelMenu="dsMotivo"
            valueMenu="idParamFaleConosco"
            listOptions={
              parametrizationTalkToUs?.idParamFaleConosco
                ? [parametrizationTalkToUs]
                : []
            }
          />
        </Grid>
        <Grid
          gridCols="1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Input
            label="E-mail Solicitante"
            value={userSolicitanteName}
            disabled
            multiline
            placeholder="Mensagem"
          />
          <Input
            label="Contrato"
            value={userContrato}
            disabled
            multiline
            placeholder="Mensagem"
          />
          <Input
            label="Mensagem"
            value={userMessage}
            disabled
            multiline
            placeholder="Digite aqui a sua mensagem"
          />
        </Grid>
      </SimpleCollapse>
      <SimpleCollapse title="Resposta" textColor={COLORS.black}>
        <Grid
          gridCols="1fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Input
            label="Digite aqui a sua mensagem"
            formValue="txtResposta"
            multiline
            maxLength={4000}
            value={talkToUs.txtResposta}
            onChange={handleOnChange}
            placeholder="Mensagem"
            disabled={respondido}
          />
        </Grid>
        <Row justifyContent="flex-end" marginTop={SPACING.spacing10}>
          <Button
            text="Salvar"
            disabled={respondido || talkToUs.txtResposta?.trim().length == 0}
            onClick={handleOnSave}
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
          />
        </Row>
      </SimpleCollapse>
    </Card>
  )
}

export default TalkToUsForm
